import { render, staticRenderFns } from "./PaginaBasica.vue?vue&type=template&id=161030a0&scoped=true&"
import script from "./PaginaBasica.vue?vue&type=script&lang=js&"
export * from "./PaginaBasica.vue?vue&type=script&lang=js&"
import style0 from "./PaginaBasica.vue?vue&type=style&index=0&id=161030a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161030a0",
  null
  
)

export default component.exports